import "./style.css";
import React from "react";
import InstagramIcon from "@mui/icons-material/Instagram";
import fundamentalImg from "../../../resources/fundamentalne.jpg";
import formacijeImg from "../../../resources/fundamental.jpg";
import kreativnaImg from "../../../resources/kreativna_formacija.jpg";
import fadeImg from "../../../resources/sth_3.jpg";
import { useNavigate } from "react-router-dom";
import EducationBreadcrumb from "../../../common/EducationBreadcrumb";

export const WorkshopEducation = () => {
    const phoneNumber = "+381 60-3859-426";
    const navigate = useNavigate();
    const [fadeIn, setFadeIn] = React.useState(false);

    React.useEffect(() => {
        window.scrollTo(0, 0);

        // Trigger fade in after a brief delay
        setTimeout(() => {
            setFadeIn(true);
        }, 10);
    });

    const HandleOpenMap = () => {
        const url = `https://maps.app.goo.gl/6wxPp2i9rRZ45HQs6`;
        window.open(url, "_blank");
    };

    return (
        <div
            className='page-workshop'
            style={{
                animation: "fadeIn 0.05s ease-in-out",
            }}
        >
            <EducationBreadcrumb />
            <div className={`items-workshop ${fadeIn ? "fade-in" : ""}`}>
                <div
                    style={{
                        backgroundColor: "rgba(27, 29, 33, 0.85)",
                        border: "2px solid #be9455",
                        borderRadius: "12px",
                        padding: "25px 30px",
                        width: "95%",
                        maxWidth: "600px",
                        boxShadow: "0 4px 12px rgba(0, 0, 0, 0.3)",
                        marginBottom: "0px",
                        marginTop: "-10px",
                    }}
                >
                    <h1
                        style={{
                            fontSize: "24px",
                            textAlign: "center",
                            width: "100%",
                            color: "#f3f3f3",
                            lineHeight: "1.5",
                            margin: "0",
                            fontWeight: "normal",
                        }}
                    >
                        Svaka radionica nudi jedinstveno iskustvo prilagođeno
                        različitim nivoima i tehnikama barberinga.
                    </h1>
                </div>
                <h1 style={{ marginTop: "20px", marginBottom: "-70px" }}>
                    Fundamentalne
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={fundamentalImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() =>
                            navigate("/educations/workshop/fundamental")
                        }
                    >
                        Prikaži više
                    </button>
                </div>

                <h1 style={{ marginTop: "60px", marginBottom: "-70px" }}>
                    Formacije
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={formacijeImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() =>
                            navigate("/educations/workshop/formation")
                        }
                    >
                        Prikaži više
                    </button>
                </div>

                <h1 style={{ marginTop: "60px", marginBottom: "-70px" }}>
                    Kreativna Formacija
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                    }}
                >
                    <img
                        src={kreativnaImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() =>
                            navigate("/educations/workshop/creative-formation")
                        }
                    >
                        Prikaži više
                    </button>
                </div>

                <h1 style={{ marginTop: "60px", marginBottom: "-70px" }}>
                    Fade
                </h1>
                <div
                    style={{
                        position: "relative",
                        display: "inline-block",
                        marginTop: "50px",
                        marginBottom: "30px",
                    }}
                >
                    <img
                        src={fadeImg}
                        style={{
                            width: "80%",
                            height: "auto",
                            borderRadius: "15px",
                            marginLeft: "35px",
                            border: "3px solid #be9455",
                        }}
                    />
                    <button
                        style={{
                            position: "absolute",
                            top: "100%",
                            left: "50%",
                            transform: "translate(-50%, -50%)",
                            padding: "10px 20px",
                            backgroundColor: "#be9455",
                            border: "2px solid black",
                            borderRadius: "8px",
                            color: "white",
                            fontSize: "25px",
                            cursor: "pointer",
                            width: "50%",
                            fontFamily: "Bebas Neue",
                        }}
                        onClick={() => navigate("/educations/workshop/fade")}
                    >
                        Prikaži više
                    </button>
                </div>
            </div>
            <a
                className='barbershop-zajednica-footer-title-adresa'
                onClick={HandleOpenMap}
                target='_blank'
                rel='noopener noreferrer'
            >
                <div>
                    <h2>Srpskog sovjeta 1a</h2>
                    <h2>11300, Smederevo</h2>
                    <h2> Klikni me</h2>
                </div>
            </a>
            <div className='barbershop-zajednica-footer-title-adresa'>
                <h2>Posetite Instagram</h2>
                <a
                    href='https://www.instagram.com/_zajednica_/'
                    target='_blank'
                    rel='noopener noreferrer'
                    style={{
                        marginTop: "10px",
                        width: "100%",
                        justifyContent: "center",
                        display: "inline-flex",
                        alignItems: "center",
                        gap: "8px",
                        color: "#f3f3f3",
                        textDecoration: "none",
                    }}
                >
                    <InstagramIcon
                        style={{ color: "#f3f3f3", fontSize: "40px" }}
                    />
                </a>
            </div>

            <div className='barbershop-zajednica-footer-title'>
                <h2>Ili nas kontaktirajte</h2>
            </div>
            <div className='barbershop-zajednica-footer-phone'>
                <a href={`tel:${phoneNumber}`}>{phoneNumber}</a>
            </div>
        </div>
    );
};
